const Signup = () => {
    return (
        <div id="signup">
            <input type="email" placeholder="   Enter your email"/><br/>
            <input type="tel" placeholder="   Enter your phone number"/><br/>
            <input type="password" placeholder="   Enter your password"/><br/>
            <input type="password" placeholder="   Re-enter your password"/><br />
            <input type="submit" value="Signup"/>
        </div>
      );
}
 
export default Signup;